//--this will bring in alertify and its custom classes which sets the window vars

window.alertify = require('alertifyjs/build/alertify.min');

if (!alertify.customconfirm) {
	alertify.dialog('customconfirm', function factory() {
		return {
			main: function (_message, _onok, _oncancel) {
				this.setHeader('');
				this.set('message', _message);
				this.set('onok', _onok);
				this.set('oncancel', _oncancel ? _oncancel : null);
				return this;
			},
			setup: function () {
				return {
					buttons: [
						{
							text: "OK",
							className: '',
						},
						{
							text: "Cancel",
							className: 'mnw-btn-secondary',
							invokeOnClose: true
						}
					],
					focus: {
						element: 1,
						select: false
					},
					options: {
						maximizable: false,
						resizable: false,
						closable: true,
						closableByDimmer: true
					}
				};
			},
			build: function () {
				//--set-up a custom class we can use for styling
				this.elements.dialog.classList.add('customconfirm');
			}
		}
	}, false, 'confirm');
}

alertify.dialog('customalert', function factory() {
	return {
		main: function (_message) {
			this.setHeader('');
			this.set('message', _message);

			return this;
		},
		setup: function () {
			return {
				buttons: [
					{
						text: "OK",
						className: '',
					}
				],
				focus: {
					element: 0,
					select: false
				},
				options: {
					maximizable: false,
					resizable: false,
					closable: false
				}
			};
		},
		build: function () {
			//--set-up a custom class we can use for styling
			this.elements.dialog.classList.add('customalert');
		}
	}
}, false, 'alert');

if (!alertify.modalcontent) {
	//define a new dialog
	alertify.dialog('modalcontent', function factory() {
		return {
			main: function (title, content, size, onshow) {
				//--size is a json var and optional.
				//--if it specified, use dimensions.
				//--if it is not, deduce height if possible.  if not possible fall back to css
				this.setHeader(title);
				this.autoheight = 0;
				content.style.display = 'block';

				if (size) {
					if (!size.width || !size.height)
						throw 'Invalid size';

					this.set('resizable', true);

					this.resizeTo(size.width, size.height);
				} else {
					if (content.offsetHeight)
						this.autoheight = content.offsetHeight + 200;
				}

				this.setContent(content);

				if (onshow)
					this.set({onshow: onshow});
			},
			prepare: function () {
				if (this.autoheight)
					this.elements.body.style.height = this.autoheight + 'px';
			},
			setup: function () {
				return {
					options: {
						maximizable: false,
						resizable: false,
						padding: true,
						modal: true
					}
				};
			}, build: function () {
				//--set-up a custom class we can use for styling
				this.elements.dialog.classList.add('modalcontent');
			}
		}
	}, false);
}

if (!alertify.modalblock) {
	//define a new dialog
	alertify.dialog('modalblock', function factory() {
		return {
			main: function (_message) {
				if (!_message)
					_message = 'Working...';

				_message = '<div id="progressUpdate">' + _message + '<img src="/admin2/adminfiles/grfx/icon_ajax.gif" alt="Working" /></div>';

				this.setContent(_message);
				return this;
			},
			setup: function () {
				return {
					options: {
						maximizable: false,
						resizable: true,
						padding: false,
						modal: true,
						basic: true,
						closableByDimmer: false,
						closable: false
					}
				};
			},
			build: function () {
				//--set-up a custom class we can use for styling
				this.elements.dialog.classList.add('modalblock');
			}
		}
	}, false);
}